var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ServiceContent"}},[_c('div',{staticClass:"indexTitle"},[_vm._v("我们提供")]),_c('showBox',{attrs:{"msgObj":this.indexTitle_showBox_inner1}}),_c('div',{staticClass:"indexTitle"},[_vm._v("您将获得")]),_c('showBox',{attrs:{"msgObj":this.indexTitle_showBox_inner2}}),_c('NormalImg1',{attrs:{"imgUrl":_vm.FImgUrl2[0],"imgHeight":"20"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }